import { OrderType } from './HeadCell';

export default interface Paginator {
  orderBy: string;
  order: OrderType;
  searchText: string;
  rowsPerPage?: number;
  page?: number;
  groupBy?: string;
  searchBy?: string;
  paranoid?: boolean;
  filterBy?: string;
  filters?: PaginatorFilter[];
  itemPerPage?: number;
}

export interface PaginatorFilter {
  id: string;
  selectedId: number | string;
}
export const DEFAULT_ITEM_PER_PAGE_DISCOUNT_PRICES = process.env
  .REACT_APP_DEFAULT_ITEM_PER_PAGE_DISCOUNT_PRICES
  ? Number(process.env.REACT_APP_DEFAULT_ITEM_PER_PAGE_DISCOUNT_PRICES)
  : 5;
